import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { IGiftItem } from 'base/interfaces/product';
import { LoopRender } from '@base/snippets/LoopRender';
import Image from '@base/lib/ThemeImage';

type IProps = {
    className?: string;
    gifts: IGiftItem[];
    onQuickView: (variantId: string) => void;
};

export const GiftsPopupBody: FC<IProps> = props => {
    const { className, gifts, onQuickView } = props;
    const { t } = useTrans();

    return (
        <div className={className}>
            <div className={'g-tip'}>{t('web_common_free_gift_limited_tip')}</div>
            <LoopRender
                list={gifts}
                render={item => (
                    <div className={'g-item flex'} onClick={() => onQuickView(item.variantId)}>
                        <div className="relative g-item-left">
                            <Image
                                src={item.pic}
                                width={68}
                                background={false}
                                fixed
                            />
                            <div className="g-tag">{t('web_shop_order_perk')}</div>
                        </div>
                        <div className="flex-1">
                            <div className={'g-title'}>{item.title}</div>
                            <div className={'g-price-num flex flex-justify'}>
                                <span>Free</span>
                                <span>x{item.num}</span>
                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    )
};
